import moment from "moment";
import { useTranslation } from "react-i18next";
import React from "react";
import styled from "styled-components";
import { DocValidationUtils } from "../../doc-validation/doc-validation.utils";
import { renderDate } from "../../../../shared/shared.utils";
import { IRiskRatingHistoryEntry } from "../doc-risk-rating-history.model";

interface IDDocRiskRatingHistoryListProps {
  riskRatingEntries?: IRiskRatingHistoryEntry[];
}
export const mapRiskRating = (riskRating: string): "LOW_RISK" | "MEDIUM_RISK" | "HIGH_RISK" | "UNKNOWN" => {
  switch (riskRating) {
    case "1":
      return "LOW_RISK";
    case "2":
      return "MEDIUM_RISK";
    case "3":
      return "HIGH_RISK";
    default:
      return "UNKNOWN";
  }
};

export const mapRiskRatingLabel = (riskRating: string, t: any): string => {
  switch (riskRating) {
    case "1":
      return "Low Risk";
    case "2":
      return "Medium Risk";
    case "3":
      return "High Risk";
    default:
      return t("general.unknown") || "Unknown";
  }
};
const DocRiskRatingHistoryList: React.FC<IDDocRiskRatingHistoryListProps> = ({
  riskRatingEntries,
}: IDDocRiskRatingHistoryListProps) => {
  const { t } = useTranslation();
  return (
    <ListContainer>
      {riskRatingEntries &&
        riskRatingEntries.map((entry, index) => {
          return (
            <StatusEntry
              key={index}
              color={DocValidationUtils.getRiskRatingStatusColor(mapRiskRating(entry.riskRating))}
            >
              {entry.operator === "System" ? t("pages.docSubmissionDetails.systemHistoryLabel") : entry.operator}
              <TextLabel color={DocValidationUtils.getRiskRatingStatusColor(mapRiskRating(entry.riskRating))}>
                {mapRiskRatingLabel(entry.riskRating, t)}
              </TextLabel>

              <TextLabel>{renderDate({ date: moment(entry.updatedAt) })}</TextLabel>
            </StatusEntry>
          );
        })}
    </ListContainer>
  );
};

export default DocRiskRatingHistoryList;

const ListContainer = styled("div")`
  margin-top: 20px;
`;

const StatusEntry = styled("div")<{ color: string }>`
  font-family: Vodafone Rg;
  font-size: 14px;
  line-height: 1.4;
  display: inline-block;
  border-left: 3px solid ${props => props.color};
  padding-right: 35px;
  padding-left: 9px;
  margin-bottom: 15px;
  vertical-align: top;
`;

const TextLabel = styled("div")<{ color?: string }>`
  color: ${props => (props.color ? props.color : props.theme.palette.midGrey)};
`;
